module.exports = __webpack_public_path__ + "img/bread-flows.7c7115eb.png";